import React, { useEffect, useMemo, useRef, useState } from 'react';
import SemanticHeader from '../../platformui/Chapter/semantic-header';
import useSessionStorage from '../../platformui/Hooks/useSessionStorage';
import useWindowLocationHref from '../../platformui/Hooks/useWindowLocation';
import Section from './../../platformui/Section/index';
import LetterSlideModal from './letter-slide-modal';

const LetterSlidesContainer = ({
  openModalBtnText,
  nextBtnText,
  backBtnText,
  popoverText,
  popoverBtnText,
  mainContent,
  shareButton,
  heading,
  introText,
  blockId,
}) => {
  const letterDataKey = 'letterSlideData-' + blockId;
  const [isOpen, setIsOpen] = useState(false);
  const [wasModalOpened, setWasModalOpened] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [letterData, setLetterData] = useSessionStorage(
    letterDataKey,
    {},
    3600000
  );
  const openModalButtonRef = useRef(null);

  const finalLetterOutputKey = 'FinalLetterData';

  const href = useWindowLocationHref();

  const backgroundIndices = useMemo(() => {
    return mainContent?.map(() => Math.floor(Math.random() * 5));
  }, [mainContent]);

  const randomBackground = backgroundIndices?.[currentIndex];

  const nextSlide = () => {
    if (currentIndex < mainContent.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleOnClickOpen = () => {
    setIsOpen(true);
  };

  const handleOnClickClose = () => {
    setIsOpen(false);
    setCurrentIndex(0);
  };

  const updateLetterData = (slideKey, heading, value) => {
    setLetterData((prev) => ({
      ...prev,
      [slideKey]: {
        heading,
        value,
      },
    }));
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
      setWasModalOpened(true);
    } else if (wasModalOpened) {
      openModalButtonRef.current?.focus();
    }

    return () => {
      document.body.removeAttribute('class');
    };
  }, [isOpen]);

  if (!mainContent) return null;

  return (
    <Section customClass="c-letter-slides-container">
      <div className="letter-slides">
        <SemanticHeader>{heading}</SemanticHeader>
        <p>{introText}</p>
        <button
          ref={openModalButtonRef}
          className="button button--primary"
          aria-label="öppna dialogrutan"
          onClick={handleOnClickOpen}
          data-event-category={href || 'novalue'}
          data-event-action="ModalBlocket"
          data-event-name={'0 ' + openModalBtnText}
        >
          {openModalBtnText}
        </button>
        {isOpen && (
          <LetterSlideModal
            randomBackground={randomBackground}
            currentIndex={currentIndex}
            mainContent={mainContent}
            popoverBtnText={popoverBtnText}
            popoverText={popoverText}
            letterData={letterData}
            setLetterData={setLetterData}
            updateLetterData={updateLetterData}
            finalLetterKey={finalLetterOutputKey}
            handleOnClickClose={handleOnClickClose}
            prevSlide={prevSlide}
            nextSlide={nextSlide}
            backBtnText={backBtnText}
            nextBtnText={nextBtnText}
            shareButton={shareButton}
          />
        )}
      </div>
    </Section>
  );
};

export default LetterSlidesContainer;
